//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopFilter from '@/views/map/_top_filter'
import ZoneSelect from '@/views/map/_zone_select'
import PriceSelect from '@/views/map/_price_select'
import LayoutSelect from '@/views/map/_layout_select'
import AreaSelect from '@/views/map/_area_select'
import DecorateSelect from '@/views/map/_decorate_select'

import Service from '@/service'

import API from '@/service/whole_buildings'

import pagination from '@/common/mixins/pagination'

import MapSection from './_map'
import ListSection from './_list'

import { getSelectBuilding, putSelectBuilding } from './store'

const TYPES = {
    ZONES: 'zones',
    SECTIONS: 'sections',
    BUILDINGS: 'buildings'
}
const MARKER_STYLE = {
    iconPath: 'https://cdn.vip-wifi.com/fangchan/img/packageA/map/zone-icon.png',
    width: 10,
    height: 10
}

const ZONE_STYLE = {
    ...MARKER_STYLE,
    iconPath: 'https://cdn.vip-wifi.com/fangchan/img/packageA/map/transparent.png',
}

const MARKER_SELECT_STYLE = {
    ...MARKER_STYLE,
    iconPath: 'https://cdn.vip-wifi.com/fangchan/img/packageA/map/select-zone.png'
}

const CALLOUT_STYLE = {
    color: '#ffffff',
    fontSize: 12,
    bgColor: '#6699CC',
    borderRadius: '50px',
    padding: '10px',
    border: 0,
    boxShadow: '0 1px 2px 0 rgba(125, 100, 72, .3)',
    textAlign: 'center'
}
const SECTION_CALLOUT_STYLE = {
    ...CALLOUT_STYLE,
    padding: '14px',
    bgColor: '#37A6B8'
}

const SELECT_CALLOUT_STYLE = {
    ...CALLOUT_STYLE,
    bgColor: '#FF4D00'
}

const ZONE_CALLOUT_STYLE = {
    ...CALLOUT_STYLE,
    padding: '14px',
    bgColor: '#00B08D'
}

const getHouseMarkers = (houses, select_id) => {
    return houses.map(({ id, location, name, apartment_count: count }) => {
        const [longitude, latitude] = location.split(',')
        const count_str = count ? `(${count}套)` : ''
        const _default = {
            id,
            title: name,
            latitude,
            longitude,
        }
        const content = `${name}${count_str}`
        if (select_id === id) {
            return {
                ..._default,
                ...MARKER_SELECT_STYLE,
                zIndex: 20,
                callout: {
                    content,
                    ...SELECT_CALLOUT_STYLE
                }
            }
        }
        return {
            ..._default,
            ...MARKER_STYLE,
            callout: {
                content,
                ...CALLOUT_STYLE
            }
        }
    })
}

const getZoneMarkers = (zones) => {
    return zones.map(({ id, name, building_count, location }) => {
        const [longitude, latitude] = location.split(',')
        const count_str = building_count ? `${building_count}个` : ''
        return {
            id,
            title: name,
            latitude,
            longitude,
            ...ZONE_STYLE,
            callout: {
                content: `${name}\n(${count_str})`,
                ...ZONE_CALLOUT_STYLE
            }
        }
    })
}

const getSectionMarkers = (sections) => {
    return sections.map(({ id, name, building_count, location }) => {
        const [longitude, latitude] = location.split(',')
        const count_str = building_count ? `${building_count}个` : ''
        return {
            id,
            title: name,
            latitude,
            longitude,
            ...ZONE_STYLE,
            callout: {
                content: `${name}\n(${count_str})`,
                ...SECTION_CALLOUT_STYLE
            }
        }
    })
}
let mapCtx
let houses = []
let sections = []
let zones = []

const config = {
    scale: 9
}

const hasOtherFilter = (filter, is_surplus = false) => {
    let other_key = ['total_price', 'price', 'layout', 'decoration', 'area', 'metro', 'status']
    if (is_surplus) {
        other_key = other_key.filter(key => key != 'status')
    }
    return other_key.some((key) => filter[key])
}

export default {
    mixins: [
        pagination
    ],
    components: {
        TopFilter,
        ZoneSelect,
        PriceSelect,
        LayoutSelect,
        AreaSelect,
        DecorateSelect,
        MapSection,
        ListSection
    },
    data () {
        return {
            type: TYPES.ZONES,
            select_id: '',
            decoration: '',
            zone_ids: '',
            zone_section_ids: '',
            area: '',
            total_price: '',
            price: '',
            layout: '',
            metro: '',

            markers: [],
            status: '',

            selected: '',
            is_surplus: false,

            text: {
                '区域': '区域',
                '城区': '',
                '地铁': '',
                '价格': '价格',
                '户型': '户型',
                '面积': '面积',
                '装修': '装修'
            },
            page_type: 'map'
        }
    },
    created () {
        if (this.app_type === 'tft') {
            ZONE_CALLOUT_STYLE.color = '#333'
            ZONE_CALLOUT_STYLE.bgColor = '#FFC230'
            ZONE_CALLOUT_STYLE.fontWeight = 'bold'
            ZONE_CALLOUT_STYLE.boxShadow = '0 2px 10px 0 rgba(255,207,128,0.50)'
            console.log('ZONE_CALLOUT_STYLE', ZONE_CALLOUT_STYLE)
        }
        this.$watch(function () {
            return this.text['城区'] + this.text['地铁']
        }, function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.text['区域'] = newVal || '不限'
            }
        })
    },
    mounted () {
        const options = this.$route.query
        this.is_surplus = options.status === '摇号剩余'
        this.status = this.is_surplus ? '摇号剩余' : ''
        config.scale = 9
        this.getZones()
    },
    destroyed () {
        zones = []
        sections = []
        houses = []
        putSelectBuilding(null)
    },
    async onShow () {
        const item = getSelectBuilding()
        if (item && this.page_type === 'map') {
            this.select_id = item.id || ''
            this.zone_ids = item.zone_id || ''
            this.zone_section_ids = item.zone_section_id || ''
            if (item.zone_id) {
                this.text['城区'] = item.zone
                await this.getSections()
            }
            if (item.zone_section_id) {
                this.text['城区'] += `,${item.zone_section}`
                this.getHouses()
            }
        }
    },
    computed: {
        show_back () {
            return this.type != TYPES.ZONES
        }
    },
    onShareAppMessage () {
        const { status } = this.$route.query
        const main_path = this.is_surplus ? '/pages/packageA/surplus_buildings/main' : '/pages/find_building/main'
        const sub_page = encodeURIComponent(`/pages/packageA/whole_buildings_map/main?status=${status || ''}`)
        let title = this.is_surplus ? '这里有成都的在售楼盘，地图直接查看更方便哦' : '地图找房方便又直观，快来找找你心仪的楼盘喔~'
        const shareOpt = {
            title,
            path: `${main_path}?sub_page=${sub_page}`,
            share_by_prefix: 'sp201904183_'
        }
        return this.getShareInfo(shareOpt)
    },
    methods: {
        getZones () {
            let options = ['zone_ids', 'zone_section_ids', 'total_price', 'price', 'layout', 'decoration', 'area', 'metro', 'status'].reduce((prev, key) => {
                if (this[key]) {
                    prev[key] = this[key]
                }
                return prev
            }, {})
            API.map_zones(options).then(({ items }) => {
                this.type = TYPES.ZONES
                if (items.length) {
                    zones = items
                    this.drawZones()
                } else {
                    this.$wx.showModal({
                        title: '提示',
                        content: '没有符合条件的楼盘',
                        showCancel: false
                    })
                }
            })
        },
        drawZones () {
            this.markers = getZoneMarkers(zones)
        },
        drawSection (sections) {
            this.markers = getSectionMarkers(sections)
        },
        drawHouses (houses) {
            this.markers = getHouseMarkers(houses, this.select_id)
        },
        changeStatus (status) {
            this.select_id = ''
            this.status = this.status === status ? '' : status
            if (this.page_type === 'map') {
                switch (this.type) {
                    case TYPES.ZONES:
                        this.getZones()
                        break
                    case TYPES.SECTIONS:
                        this.getSections()
                        break
                    case TYPES.BUILDINGS:
                        this.getHouses()
                        break
                }
            } else {
                this.page = 1
                this.getData()
            }
        },
        getSections (markerId = this.zone_ids) {
            this.zone_ids = markerId
            let options = ['total_price', 'zone_ids', 'zone_section_ids', 'price', 'layout', 'decoration', 'area', 'metro', 'status'].reduce((prev, key) => {
                if (this[key]) {
                    prev[key] = this[key]
                }
                return prev
            }, {})
            return API.map_zone_sections(options).then((data) => {
                sections = data.items
                const has_other_filter = hasOtherFilter(options, this.is_surplus)
                if (data.items.length || has_other_filter) {
                    this.type = TYPES.SECTIONS
                    this.drawSection(sections)
                }

                if (!data.items.length) {
                    if (has_other_filter) {
                        this.$wx.showModal({
                            title: '提示',
                            content: '该区域内没有符合的楼盘',
                            showCancel: false
                        })
                    } else {
                        this.type = TYPES.BUILDINGS
                        this.getHouses('')
                    }
                }
            })
        },
        getHouses (markerId = this.zone_section_ids) {
            this.zone_section_ids = markerId
            let options = ['total_price', 'zone_ids', 'zone_section_ids', 'price', 'layout', 'decoration', 'area', 'metro', 'status'].reduce((prev, key) => {
                if (this[key]) {
                    prev[key] = this[key]
                }
                return prev
            }, {})
            API.map_buildings(options).then((data) => {
                houses = data.items.filter(({ location }) => location)
                this.drawHouses(houses)
                this.type = TYPES.BUILDINGS
                if (!houses.length) {
                    this.$wx.showModal({
                        title: '提示',
                        content: '该区域内没有符合条件的楼盘',
                        showCancel: false
                    })
                }
            })
        },
        clickCallout (e) {
            if (this.selected) {
                this.hideSelect()
                return
            }
            const { markerId } = e.mp
            if (this.type === TYPES.ZONES) {
                zones.some(({ name, id }) => {
                    if (markerId === id) {
                        this.text['城区'] = name
                        return true
                    }
                })
                this.type = TYPES.SECTIONS
                this.getSections(markerId)
            } else if (this.type === TYPES.SECTIONS) {
                sections.some(({ name, id }) => {
                    if (markerId === id) {
                        this.text['城区'] += `,${name}`
                        return true
                    }
                })
                this.type = TYPES.BUILDINGS
                this.getHouses(markerId)
            } else {
                const from = this.status === '摇号剩余' ? 'surplus_buildings' : ''
                this.$router.push({
                    path: `/building?building_id=${markerId}&from=${from}`
                })
            }
        },
        clickMap (e) {
            if (e.target.id === 'map') {
                this.hideSelect()
            }
        },
        changeFilter (filter) {
            Object.keys(filter).forEach((key) => {
                this[key] = filter[key]
            })
            if (this.page_type === 'map') {
                if (this.type === TYPES.ZONES) {
                    this.getZones()
                } else if (this.type === TYPES.SECTIONS) {
                    this.getSections()
                } else {
                    this.getHouses()
                }
            } else {
                this.page = 1
                this.getData()
            }
        },
        changeSelect (selected) {
            this.selected = selected
        },
        hideSelect () {
            this.changeSelect('')
        },
        changeZone (zone_ids, text, zone_section_ids) {
            this.select_id = ''
            this.text['城区'] = text === '不限' ? '' : text
            this.hideSelect()
            if (this.page_type === 'map') {
                if (zone_section_ids && zone_section_ids != this.zone_section_ids) {
                    this.getHouses(zone_section_ids)
                } else if (zone_ids && zone_ids != this.zone_ids) {
                    this.zone_section_ids = ''
                    this.getSections(zone_ids)
                } else if (!zone_ids) {
                    this.zone_section_ids = ''
                    this.zone_ids = zone_ids
                    this.getZones()
                }
            } else {
                this.zone_section_ids = zone_section_ids
                this.zone_ids = zone_ids
                this.page = 1
                this.getData()
            }
        },
        changeMetro (metro) {
            if (this.metro != metro) {
                this.text['地铁'] = metro
                this.hideSelect()
                this.changeFilter({
                    metro
                })
            }
        },
        changePrice (type, tmp_price, selected_tx) {
            this.select_id = ''
            this.text['价格'] = selected_tx
            this.hideSelect()
            const total_price = type === 'water' ? tmp_price : ''
            const price = type === 'square' ? tmp_price : ''
            this.changeFilter({
                total_price,
                price
            })
        },
        changeLayout (layout) {
            this.select_id = ''
            this.text['户型'] = layout
            this.hideSelect()
            this.changeFilter({
                layout
            })
        },
        changeArea (area, text) {
            this.select_id = ''
            this.text['面积'] = text
            this.hideSelect()
            this.changeFilter({
                area
            })
        },
        changeDecorate (decoration) {
            this.select_id = ''
            this.text['装修'] = decoration
            this.hideSelect()
            this.changeFilter({
                decoration
            })
        },
        back () {
            this.select_id = ''
            if (this.type === TYPES.BUILDINGS && sections.length) {
                this.zone_section_ids = ''
                this.text['城区'] = this.text['城区'].split(',')[0]
                this.getSections(this.zone_ids)
            } else {
                this.text['城区'] = ''
                this.zone_ids = ''
                this.zone_section_ids = ''
                this.getZones()
            }
        },
        switchPageType () {
            this.page_type = this.page_type === 'map' ? 'list' : 'map'
            this.text['城区'] = ''
            this.zone_ids = ''
            this.zone_section_ids = ''
            if (this.page_type === 'map') {
                this.getZones()
            } else {
                this.page = 1
                this.getData()
            }
        },
        async getData () {
            this.loading = true
            let options = ['total_price', 'zone_ids', 'zone_section_ids', 'price', 'layout', 'decoration', 'area', 'metro', 'status'].reduce((prev, key) => {
                if (this[key]) {
                    prev[key] = this[key]
                }
                return prev
            }, {})
            const data = await Service.getBuildings({
                page: this.page,
                ...options
            })
            this.handleData(data)
            this.$nextTick(() => {
                if (this.page === 1) {
                    wx.pageScrollTo({
                        scrollTop: 0
                    })
                }
            })
        },
        onSearch() {
            this.$router.push({
                path:`/pages/packageA/whole_buildings_map/search?from=${this.page_type}`
            })
        }
    }
}
